import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Circle from "react-circle";

import { HeaderHome } from '../../../components/molecues';
import { ScrollView, Select, LoadingView } from '../../../../common/components/atoms';
import { convISO8601 } from '../../../../common/helper/commonHelper.js'
import { TEACHING_NUMBER } from '../../../common/constants.js'
import { getMondayDate} from '../../../../common/helper/commonHelper.js';

import icon_training from '../../../components/atoms/data/icon_training.svg';
import icon_nikkei from '../../../components/atoms/data/icon_nikkei.svg';
import icon_cognitive from '../../../components/atoms/data/icon_cognitive.svg';
import icon_tutorial from '../../../components/atoms/data/icon_tutorial.svg';
import icon_webInfo from '../../../components/atoms/data/icon_webInfo.svg';
import icon_webArchive from '../../../components/atoms/data/icon_webArchive.svg';
import icon_option from '../../../components/atoms/data/icon_option.svg';
import icon_toeic from '../../../components/atoms/data/icon_toeic.svg';
import icon_faq from '../../../components/atoms/data/icon_faq.svg';
import icon_account from '../../../components/atoms/data/icon_account.svg';
import banner_studyHacker from '../../../components/atoms/data/banner_studyHacker.svg';
import banner_strail from '../../../components/atoms/data/banner_strail.svg';

class Home extends Component {
    constructor(props) {
        super(props);

        this.refScroll = React.createRef();
        this.refTeaching = React.createRef();

        //曜日の定義 月曜日～日曜日
        let today = new Date();
        let setMondayDate = getMondayDate(today);
      
        this.state = {
            current: 0,
            course: this.props.course ? this.props.course : null,
            user: this.props.user ? this.props.user : null,
            simplePlan:true,
            weeksGoalList: {id: "", weekGoal: 0, weekTotal: 0, progressRate: 0, total: 0},
            weeksGoalDisplay: false,
            simplePlanDisplay: false,
            setMondayDate: setMondayDate,
            selectedValue:0,
            noticeFlg: false,
            webAcvFlg: false,
            webInfoFlg: false,
        }
        
    }
    componentDidMount() {
        localStorage.removeItem('GrammarScroll');
        this.props.dispatch({
            type: "LoadStart"
        });
        this.homeReload();
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    homeReload = () => {
        this.props.dispatch({
            type: "GetCourseInfo_Saga",
        });
        this.props.dispatch({
            type: "GetWeeksGoal_Saga",
            userID: this.props.user.id,
            date: this.state.setMondayDate,
            onSuccess: this.onSuccessGetWeeksGoal,
            onFailure: this.onFailure,
        });
        this.props.dispatch({
            type: "GetWebinarArchiveRead_Saga",
            userID: this.props.user.id,
            onSuccess: this.onSuccessGetWebinarArchiveRead,
            onFailure: this.onFailure,
        });
        this.props.dispatch({
            type: "GetWebinarInfoRead_Saga",
            userID: this.props.user.id,
            onSuccess: this.onSuccessGetWebinarInfoRead,
            onFailure: this.onFailure,
        });
        this.props.dispatch({
            type: "GetNoticeList_Saga",
            id: this.props.user.id,
            onSuccess: this.onSuccessGetNoticeList,
            onFailure: this.onFailure,
        });
        //プラン判定
        //0：シンプル（無償利用中）、4：シンプル
        let courseID = this.state.user.course;
        let simplePlan;
        if(courseID === 0 || courseID === 4){
            simplePlan = true;
        }else{
            simplePlan = false;
        }
        this.setState({ simplePlan: simplePlan });
    }
    onSuccessGetNoticeList = (list) => {
        this.props.dispatch({
            type: "LoadEnd"
        });       
        const today = new Date();
        let expireDate;
        let noticeFlg = true;
        for (let key in list) {
            expireDate = new Date(convISO8601(list[key].expireDate));
            if (expireDate > today) {
                if (list[key].unread) {
                    noticeFlg = false;
                }
            }
        }
        //true:既読、false:未読 
        this.setState({ noticeFlg: noticeFlg });
    }

    onSuccessGetWeeksGoal = (items) => {

        let weeksGoalID = items[0].id;
        let weekGoal = items[0].weekGoal;
        let weekTotal = items[0].weekTotal;
        let progressRate = (items[0].weekTotal / items[0].weekGoal) * 100
        if(progressRate>=100){
            progressRate = 100;
        }
        let total = items[1].total;
        this.setState({
            weeksGoalList: {
                weeksGoalID:weeksGoalID,
                weekGoal:weekGoal,
                weekTotal:weekTotal,
                progressRate:progressRate,
                total:total
            }
        });
        let selectedValue = ("0" + (this.state.weeksGoalList.weekGoal)).slice(-2);
        this.setState({ selectedValue: selectedValue });
    }
    onSuccessSetWeeksGoal = () => {
        this.homeReload();
    }
    onSuccessGetWebinarArchiveRead = (count) => {
        //count=1:既読 count=0:未読
        let simplePlan = this.state.simplePlan;
        let webAcvFlg;
        if(simplePlan){
            webAcvFlg = true;
        }else{
            if(count === 1){
                webAcvFlg = true;
            }else{
                webAcvFlg = false;
            }
        }
        //true:既読、false:未読 
        this.props.dispatch({
            type: "LoadHome",
            webAcvFlg: webAcvFlg,
        });
        this.setState({
            webAcvFlg: webAcvFlg
        });
    }

    onSuccessGetWebinarInfoRead = (count) => {
        //count=1:既読 count=0:未読
        let simplePlan = this.state.simplePlan;
        let webInfoFlg;
        if(simplePlan){
            webInfoFlg = true;
        }else{
            if(count === 1){
                webInfoFlg = true;
            }else{
                webInfoFlg = false;
            }
        }
        //true:既読、false:未読 
        this.props.dispatch({
            type: "LoadHome",
            webInfoFlg: webInfoFlg,
        });
        this.setState({
            webInfoFlg: webInfoFlg
        });
       
    }
    closeMenu = () => {
        this.setState({ menuDisplay: false });
    }
    onClickTop = () => {
        this.props.history.push('/top');
    }
    onClickTutorial = () => {
        this.props.history.push('/tutorial')
    }
    onClickCognitive = () => {
        if(this.state.simplePlan){
            this.setState({ simplePlanDisplay: true });
        }else{
            this.props.history.push('/cognitiongrammar');
        }
    }
    onClickWebInfo = () => {
        if(this.state.simplePlan){
            this.setState({ simplePlanDisplay: true });
        }else{
            this.props.dispatch({
                type: "LoadHome",
                contentID: 1,
                current: 2,
            });
            this.props.history.push('/Content');
        }

    }
    onClickWebArchive = () => {
        if(this.state.simplePlan){
            this.setState({ simplePlanDisplay: true });
        }else{
            this.props.history.push('/WebinarArchive');
        }
    }
    onClickOption = () => {
        this.props.dispatch({
            type: "LoadHome",
            contentID: 2,
            current: 4,
        });
        this.props.history.push('/Content');
    }
    onClickToeic = () => {
        this.props.dispatch({
            type: "LoadHome",
            contentID: 3,
            current: 5,
        });
        this.props.history.push('/Content');
    }
    onClickNotice = () => {
        this.props.history.push('/Notice');
    }
    onClickFaq = () => {
        this.props.history.push('/Faq');
    }
    onClickAccount = () => {
        this.props.history.push('/Account');
    }
    onClickWeeksGoal = () => {
        this.setState({ weeksGoalDisplay: true });
    }

    closeWeeksGoal = () => {
        this.setState({ weeksGoalDisplay: false });
    }
    changSelectedValue = (e) => {
        this.setState({ selectedValue: e.target.value });

    }
    changeWeeksGoal = () => {
        this.props.dispatch({
            type: "SetWeeksGoal_Saga",
            userID: this.props.user.id,
            date: this.state.setMondayDate,
            weeksGoal: Number(this.state.selectedValue),
            onSuccess: this.onSuccessSetWeeksGoal,
            onFailure: this.onFailure,
        });
        this.setState({ weeksGoalDisplay: false });
    }
    closeSimplePlan = () => {
        this.setState({ simplePlanDisplay: false });
    }
    createContents = () => {
        const iconWidth = "50px";   //30    50
        const circle = "140";       //100   140
        const size = 17             //13    17
        const fontsize = size + "px"
        const wLinesize = (size - 1) + "px"

        const circleWidth = circle + "px"

        let webinfoStyle = { display: "none" };
        let webAcvStyle = { display: "none" };
        if(!this.state.webInfoFlg){
            webinfoStyle = { color: "red" };
        }
        if(!this.state.webAcvFlg){
            webAcvStyle = { color: "red" };
        }
        return(
                <React.Fragment>
                <Training onClick={this.onClickTop}>
                    <TrainingIcon>
                        <img alt="icon_training" src={icon_training} width="75px" style={{margin: "auto"}} />
                    </TrainingIcon>
                    <TrainingText>トレーニングを始める</TrainingText>
                </Training>
                    <GroupA>
                        <WeeksGoal>
                            <RegularText>今週の目標</RegularText>
                            <LargeText>{this.state.weeksGoalList.weekGoal}</LargeText>
                            <Boldtext>教材</Boldtext>
                            <IconButton onClick={this.onClickWeeksGoal}>変更</IconButton>
                        </WeeksGoal>
                        <Total>
                            <RegularText>累計</RegularText>
                            <LargeText>{this.state.weeksGoalList.total}</LargeText>
                            <Boldtext>教材</Boldtext>
                        </Total>
                    </GroupA>
                    <WeeksProgress width={circleWidth} height={circleWidth}>
                        <Circle
                            progress={this.state.weeksGoalList.progressRate}  //進捗率
                            size={circleWidth}          //円グラフのサイズ
                            lineWidth="40px"            //円グラフの線幅
                            progressColor="#00b050"     //進捗の色
                            bgColor="#c5e0b4"           //残部分の色
                            textColor="#000"            //進捗文字の色
                            showPercentage={false}      // 進捗数値部分を表示させるかどうか
                            showPercentageSymbol={false}    // 進捗の%部分を表示させるかどうか
                            />
                        <CircleText>
                            <div>今週の進捗</div>
                            <TextChild>
                                <TextEmphasis>
                                {this.state.weeksGoalList.weekTotal}
                                </TextEmphasis>
                                <TextNormal>
                                    教材
                                </TextNormal>
                            </TextChild>
                        </CircleText>
                    </WeeksProgress>
                <ContentBar FontSize={fontsize} >　学習コンテンツ</ContentBar>
                    <GroupB>
                        <ContentBoxACenter onClick={this.onClickTutorial} FontSize={fontsize}>
                            <img alt="ecprime-logo" src={icon_tutorial} width={iconWidth} style={{margin: "auto"}} />
                            チュートリアル動画
                        </ContentBoxACenter>
                        <ContentBoxLink target="_blank" href="https://asia.nikkei.com/" FontSize={fontsize}>
                            <img alt="ecprime-logo" src={icon_nikkei} width={iconWidth} style={{margin: "auto"}} />
                            Nikkei Asia
                        </ContentBoxLink>
                    </GroupB>
                    <GroupB>
                        <ContentBoxACenter onClick={this.onClickCognitive} FontSize={fontsize}>
                            <img alt="ecprime-logo" src={icon_cognitive} width={iconWidth} style={{margin: "auto"}} />
                            認知文法動画
                        </ContentBoxACenter>
                        <ContentBoxA onClick={this.onClickWebArchive} FontSize={fontsize}>
                        <UnreadMarkA>
                            <MarkA>{<i className="fas fa-circle fa-xs" style={webAcvStyle} />}</MarkA>
                        </UnreadMarkA>
                            <img alt="ecprime-logo" src={icon_webArchive} width={iconWidth} style={{margin: "auto"}} />
                            <ContentText FontSize={wLinesize}>ウェビナーの<br />アーカイブ</ContentText>
                        </ContentBoxA>
                    </GroupB>
                <ContentBar FontSize={fontsize}>　各種お申し込み</ContentBar>
                    <GroupB>
                        <ContentBoxC onClick={this.onClickOption} FontSize={fontsize}>
                            <img alt="ecprime-logo" src={icon_option} width={iconWidth} style={{margin: "auto"}} />
                            <ContentText FontSize={wLinesize}>オプション<br />トレーニング</ContentText>
                        </ContentBoxC>
                        <ContentBoxC onClick={this.onClickToeic} FontSize={fontsize}>
                            <img alt="ecprime-logo" src={icon_toeic} width={iconWidth} style={{margin: "auto"}} />
                            <ContentText FontSize={wLinesize}>TOEIC®<br />公開テスト<br />オンラインIPテスト</ContentText>
                        </ContentBoxC>
                    </GroupB>
                <ContentBar FontSize={fontsize}>　その他</ContentBar>
                    <GroupB>
                        <ContentBoxA onClick={this.onClickFaq} FontSize={fontsize}>
                            <img alt="ecprime-logo" src={icon_faq} width={iconWidth} style={{margin: "auto"}} />
                            よくある質問
                        </ContentBoxA>
                        <ContentBoxA  onClick={this.onClickAccount} FontSize={fontsize}>
                            <img alt="ecprime-logo" src={icon_account} width={iconWidth} style={{margin: "auto"}} />
                            アカウント
                        </ContentBoxA>                      
                    </GroupB>
                <Footer>
                    <a href="https://englishcompany.jp/" target="_blank" rel="noopener noreferrer"><img alt="banner_studyHacker" src={banner_studyHacker} width="120px" /></a>
                    <a href="https://strail-english.jp/" target="_blank" rel="noopener noreferrer"><img alt="banner_strail" src={banner_strail} width="120px" /></a>
                </Footer>
                </React.Fragment>
        ); 
    }

    render() {
        const propsHeader = {
            noticeFlg:this.state.noticeFlg,
            onClickNotice: this.onClickNotice,
        };
        const propsScroll = {
            width: '100%',
            height: (window.innerHeight - 64 ) + "px",
            contents: this.createContents()
        };
        const propsSelect = {
            array: TEACHING_NUMBER,
            onChange: this.changSelectedValue,
            value: this.state.selectedValue,
            style:{
                    padding: "2px 5px",
                    color: "#000",
                    width: "100px",
                    height: "40px",
                    fontSize:"16px",
                    outline: "none",
            },
        };
        return (
            <Body>
                <HeaderHome {...propsHeader}></HeaderHome>
                <ScrollView ref={this.refScroll} {...propsScroll} />
                <DialogBody Display={this.state.weeksGoalDisplay}>
                    <Back Display={this.state.weeksGoalDisplay} ></Back>
                    <Dialog Display={this.state.weeksGoalDisplay}>
                        <CloseButton onClick={this.closeWeeksGoal}>×</CloseButton>
                        <Contents>
                            今週の目標
                            <Select ref={this.state.refTeaching} {...propsSelect} />
                        </Contents>
                        <ControlWrap>
                            <Button onClick={this.closeWeeksGoal}>キャンセル</Button>
                            <Button onClick={this.changeWeeksGoal}>変更する</Button>
                        </ControlWrap>
                    </Dialog>
                </DialogBody>
                <DialogBody Display={this.state.simplePlanDisplay}>
                    <Back Display={this.state.simplePlanDisplay} ></Back>
                    <Dialog Display={this.state.simplePlanDisplay} >
                        <CloseButton onClick={this.closeSimplePlan}>×</CloseButton>
                        <ContentsSimple>
                            このコンテンツは、バリュープラン・フィードバックプランの方のみご利用いただけます。
                            <p />
                            利用するにはプランのアップグレードをお願いいたします。
                            <p />
                            プランのアップグレードは<a href="https://docs.google.com/forms/d/e/1FAIpQLScprbyPZyhaphIMsdKjuywXFitSi2Y9xL2cdX-gTjbyaOphzA/viewform" target="_blank" rel="noopener noreferrer">こちら</a>から
                        </ContentsSimple>
                        <WrapButton>
                            <Button onClick={this.closeSimplePlan}>OK</Button>
                        </WrapButton>
                    </Dialog>
                </DialogBody>
                <LoadingView Display={this.props.loading} />    
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        user: store.login.user,
        course: store.setting.course,
        loading: store.loading.loading,
        loadResult: store.loading.state,
        afterLoadMessage: store.loading.message,
        toppageScroll: store.setting.toppageScroll,
    }
};

const connectedHome = connect(mapStateToProps)(Home);
export { connectedHome as Home };

const Body = styled.div`
`;

const GroupA  = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;
const GroupB  = styled.div`
    display:flex;
    justify-content: space-around;
    color:#000;
    height:120px;
`;
const Training = styled.div`
    width: 94%;
    height: 85px;
    display: flex;
    background-color:#fff2cc;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
    padding: 3px 5px;
    margin: 5px auto;
    justify-content: center;
`;
const TrainingIcon = styled.div`
    margin:auto 0;
`;
const TrainingText = styled.div`
    font-size:25px;
    font-weight: bold;
    margin:auto 0;
`;
const WeeksGoal = styled.div`
    width: 65%;
    display:flex;
    background-color:#f2f8ee;
    border-radius: 5px;
    margin:2px;
    padding:0px 5px;
    justify-content: center;
    font-size:15px;
    align-items: center;
`;
const RegularText = styled.div`
`;
const LargeText = styled.div`
    font-size:25px;
    font-weight: bold;
    font-family: sans-serif ;
`;
const Boldtext = styled.div`
    font-weight: bold;
`;
const IconButton = styled.div`
    width:50px;
    cursor: pointer;
    background-color:#fff;
    border-radius: 4px;
    border-color:#000;
    border: 1px solid;
    font-size:14px;
    text-align:center;
    margin: 0 0 0 5px;
`;
const Total = styled.div`
    width: 35%;
    padding:0px 5px;
    display:flex;
    background-color:#f2f2f2;
    border-radius: 5px;
    margin:2px;
    justify-content: center;
    font-size:15px;
    align-items: center;
`;
const WeeksProgress = styled.div`
    position: relative;
    padding: 5px;
    text-align: center;
    margin:auto;
`;
const CircleText = styled.div`
    position: absolute;
    justify-content: center;
    font-size:15px;
    font-weight: bold; 
    line-height:24px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
`;
const TextChild = styled.div`
    display:flex;
    justify-content: center;
`;
const TextEmphasis = styled.div`
    font-size:30px;
    margin:auto 0 0 0;
`;
const TextNormal = styled.div`
    font-size:15px;
    margin:auto 0 -5px 0;
`;
const ContentBar = styled.div`
    width:100%;
    padding:5px 0px;
    background-color:#e2f0d9;
    font-weight: bold; 
    font-size:${props => (props.FontSize)};
    margin:0 auto;
`;
const ContentBoxLink = styled.a`
    width: 50%;
    display:inline-grid;
    background-color:#f2f2f2;
    border-radius: 0px;
    margin:2px;
    padding:5px;
    justify-content: center;
    font-size:${props => (props.FontSize)};
    font-weight: bold;
    &:link, &:visited, &:hover, &:active {
        color: #000;
    }   
`;
const ContentBoxA = styled.div`
    width: 50%;
    display:inline-grid;
    background-color:#f2f2f2;
    border-radius: 0px;
    margin:2px;
    padding:5px;
    justify-content: center;
    font-size:${props => (props.FontSize)};
    font-weight: bold; 
`;
const ContentBoxACenter = styled.div`
    width: 50%;
    display:inline-grid;
    background-color:#f2f2f2;
    border-radius: 0px;
    margin:2px;
    padding:5px;
    justify-content: center;
    font-size:${props => (props.FontSize)};
    font-weight: bold; 
`;
const ContentBoxC = styled.div`
    width: 50%;
    height: 105px;
    display:inline-grid;
    background-color:#f2f2f2;
    border-radius: 0px;
    margin:2px;
    padding:5px;
    justify-content: center;
    font-size:${props => (props.FontSize)};
    font-weight: bold; 
`;
const ContentText = styled.div`
    font-size:${props => (props.FontSize)};
    text-align:center;
    line-height:18px;
`;
const UnreadMarkA = styled.div`
    position: relative;
`;
const MarkA = styled.div`
    display:${props => (props.Display) ? 'none':''};
    position: absolute;
    font-size: 20px;
    color:red;
    top: -5px;
    right: 0px;
`;
const Footer = styled.div`
    width: 100%;
    display:flex;
    padding: 30px 0px;
    background-color:#fff;
    justify-content: space-evenly;
`;
const DialogBody = styled.div`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: ${props => (props.Display ? '' : 'none')};
    position: absolute;
`;
const Back = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: ${props => (props.Display ? '0.2' : '0')};
    transition-duration: 0.2s;
    width: 100%;
    height: 100%;
`;
const Dialog = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    opacity: ${props => (props.Display ? '1' : '0')};
    text-align: left;
    transition-duration: 0.2s;
    border-radius: 10px;
    width: 90%;
    max-width: 1000px;
    z-index: 3;
`;
const SimplePlan = styled.div`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: ${props => (props.Display ? '' : 'none')};
    position: absolute;
`;
const SimplePlanDialog = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    padding:0px 20px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    opacity: ${props => (props.Display ? '1' : '0')};
    text-align: left;
    transition-duration: 0.2s;
    border-radius: 10px;
    width: 55%;
    max-width: 1000px;
    z-index: 3;
`;
const WrapButton = styled.div`
    width: 100%;
    display: flex;
    margin:10px auto;
    justify-content: center;
    align-items: center;
`;
const CloseButton = styled.div`
    width: 95%;
    font-size: 25px;
    color: #808080;
    text-align: right;
`;
const ControlWrap = styled.div`
    width: 70%;
    display: flex;
    margin:10px auto;
    justify-content: space-between;
    align-items: center;
`;
const Button = styled.div`
    width:100px;
    height: 25px;
    font-size: 14px;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #ddd;
    border-radius: 20px;
    cursor: pointer;
    Color: #fff;
    background-color: #00b050;
`;
const Contents = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 10px 10px 10px;
    font-size: 18px;
    min-height: 100px;
    max-height: 480px;
    overflow-y: auto;
    line-height:0px;
`;
const ContentsSimple = styled.div`
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    font-size: 16px;
    min-height: 100px;
    max-height: 480px;
    overflow-y: auto;
    line-height: 17px;
`;